var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "719E40FB-E502-4254-B4A8-F8254C91AE06@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SearchIcon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-Room-NAV",
    transform: "translate(-90.000000, -210.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Operatory-room-menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 210.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Search_875351"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.027027,32.2540541 L26.3189189,23.5459459 C30.6972973,17.8540541 30.2594595,9.63243243 25.0054054,4.42702703 C22.1351351,1.55675676 18.4378378,0.145945946 14.6918919,0.145945946 C10.9459459,0.145945946 7.24864865,1.55675676 4.37837838,4.42702703 C-1.31351351,10.1189189 -1.31351351,19.3621622 4.37837838,25.0540541 C7.24864865,27.9243243 10.9459459,29.3351351 14.6918919,29.3351351 C17.8054054,29.3351351 20.9189189,28.3621622 23.4972973,26.3675676 L32.2540541,35.027027 C32.6432432,35.4162162 33.1297297,35.6108108 33.6648649,35.6108108 C34.1513514,35.6108108 34.6864865,35.4162162 35.0756757,35.027027 C35.8054054,34.2972973 35.8054054,33.0324324 35.027027,32.2540541 Z M14.7405405,25.3945946 C11.8702703,25.3945946 9.24324324,24.2756757 7.2,22.2810811 C3.06486486,18.1459459 3.06486486,11.3837838 7.2,7.2 C9.19459459,5.20540541 11.8702703,4.08648649 14.7405405,4.08648649 C17.6108108,4.08648649 20.2378378,5.20540541 22.2810811,7.2 C24.3243243,9.19459459 25.3945946,11.8702703 25.3945946,14.7405405 C25.3945946,17.6108108 24.2756757,20.2378378 22.2810811,22.2810811 C20.2864865,24.3243243 17.5621622,25.3945946 14.7405405,25.3945946 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.0c49474e.svg";
export { ForwardRef as ReactComponent };